import {MdLocationOn} from 'react-icons/md'
import {BsBriefcaseFill, BsStarFill} from 'react-icons/bs'
import {Link} from 'react-router-dom'
import './index.css'

const JobItem = props => {
  const {jobData} = props
  const {
    companyLogoUrl,
    employmentType,
    id,
    jobDescription,
    location,
    packages,
    rating,
    title,
  } = jobData

  return (
    <Link to={`/jobs/${id}`} className="job-link">
      <li className="job-card">
        <div className="job-header">
          <img
            src={companyLogoUrl}
            alt="company logo"
            className="company-logo"
          />

          <div className="title-rating-box">
            <h3 className="job-title">{title}</h3>

            <div className="rating-row">
              <BsStarFill className="star-icon" />
              <p className="rating-text">{rating}</p>
            </div>
          </div>
        </div>

        <div className="job-mid">
          <div className="loc-type-row">
            <div className="icon-text">
              <MdLocationOn className="loc-icon" />
              <p className="loc-text">{location}</p>
            </div>

            <div className="icon-text">
              <BsBriefcaseFill className="bag-icon" />
              <p className="type-text">{employmentType}</p>
            </div>
          </div>

          <p className="package-text">{packages}</p>
        </div>

        <hr className="divider" />

        <h4 className="desc-title">Description</h4>
        <p className="desc-text">{jobDescription}</p>
      </li>
    </Link>
  )
}

export default JobItem
